import React from 'react';
import { Redirect } from 'react-router-dom';
import ModalEnabled from '../extend/ModalEnabled';
import withSplashMessage from '../splashMessage/withSplashMessage';
import withUser from '../auth/withUser';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import {
  maskCapitalizeFirstLetter,
  maskPhone,
  maskServiceDate,
  maskServiceEndTime,
  maskServiceStartTime,
  serviceTypeSwitch,
  maskPrependComma,
  maskServiceDateNoYear
} from '../../masks';
import DetailsBar from '../shared/DetailsBar';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import SelectedDishes from '../shared/SelectedDishes';
import Loader from '../shared/Loader';
import { stringfyServerErrors } from '../../helpers/util';
import ServiceCharge from '../service/ServiceCharge';
import SkipWeekModal from '../menuSelection/SkipWeekModal';
import BackButton from '../shared/BackButton';

class ClientService extends ModalEnabled {
  state = {
    service: {},

    isDownload: false,
    isLoading: false,
    redirect_to: false
  };

  detailsBarProperties = [
    {
      label: 'Service Date & Time',
      className: 'p',
      combine: [
        { key: 'date', mask: maskServiceDate },
        { raw: ' ', className: '--new-line' },
        { key: 'start_time', mask: maskServiceStartTime },
        { key: 'end_time', mask: maskServiceEndTime }
      ]
    },
    {
      label: 'Address',
      className: 'p',
      key: 'address',
      combine: [
        { key: 'street_address' },
        { key: 'street_address_continued', mask: maskPrependComma },
        { raw: ' ', className: '--new-line' },
        { key: 'city' },
        { key: 'state', mask: maskPrependComma },
        { raw: ' ' },
        { key: 'zip_code' }
      ]
    },
    {
      label: 'Chef',
      key: 'invited_chefs',
      combine: [
        { key: 'chef', dive: 'name' },
        { raw: ' ', className: '--new-line' },
        {
          link: {
            to: 'tel:[phone_number]',
            advancedLabel: {
              key: 'chef',
              dive: 'phone_number',
              mask: maskPhone
            },
            crossOrigin: true
          }
        }
      ]
    },
    {
      label: 'Portion Size',
      key: 'portion_size',
      mask: maskCapitalizeFirstLetter
    }
  ];

  render() {
    const { service, isLoading } = this.state;

    if (isLoading) return <Loader />;

    if (this.state.redirect_to) return <Redirect to={this.state.redirect_to} />;

    return (
      <div className="cms cms--public">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/" />
            <div className="cms__bar cms__bar--wrap">
              <div className="cms__user-heading">
                <HeadingPlaceholder
                  value={`For ${maskServiceDateNoYear(service.start_time)}`}
                  label={`${serviceTypeSwitch(service.service_type)} Service`}
                />
              </div>
              <div className="cms__bar-ctas">
                <div className="align-right-ctas">
                  <p className="p">
                    Specific changes for this service (portions, time, date)?
                  </p>
                  <a
                    href={`mailto:q@theculinistas.com`}
                    className="cms__bar-cta btn btn--solid-blue"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
            <DetailsBar data={service} columns={this.detailsBarProperties} />
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <div className="row">
              <SelectedDishes
                menuSelections={service.menu_selections}
                notes={service.notes}
                instructions={service.special_instructions}
                service={service}
                isClient={true}
              />
            </div>
            <div className="row">
              <div className="row__item row__item--half">
                <ServiceCharge
                  service={service}
                  canEdit={false}
                  showTotal={true}
                />
              </div>
            </div>
            {service.id && (
              <div className="row">
                <button
                  type="button"
                  className="btn btn--hollow-red"
                  onClick={() => this.openModal('skip-week')}
                  disabled={service.skipped}
                >
                  Skip Week
                </button>
              </div>
            )}
          </div>
        </div>

        <SkipWeekModal
          isOpen={this.isOpen('skip-week')}
          closeModal={this.closeModal}
          skipWeek={this.handleSkipWeek}
        />
      </div>
    );
  }

  handleSkipWeek = (reason = '') => {
    const { service } = this.state;
    serviceAPI
      .skipService(this.state.service.id, reason)
      .then(res => {
        this.props.addMessage({
          className: 'success',
          message: `"Service: ${service.name}" has been skipped.`
        });
        this.setState({ redirect_to: '/' });
      })
      .catch(err => {
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        });
        this.closeModal();
      });
  };

  loadService(id) {
    this.setState({ isLoading: true });
    serviceAPI
      .getService(id)
      .then(service => this.setState({ service, isLoading: false }))
      .catch(this.handleErrorLoading);
  }

  handleErrorLoading = error => {
    console.log(error);
    const pathname = '/';
    const redirect_to = { pathname };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        redirect_to.pathname = redirect_url;
      }

      if (redirect_payload) redirect_to.state = { ...redirect_payload };
    }
    this.props.addMessage({
      className: 'error',
      message: stringfyServerErrors(error)
    }); // todo: add messaging
    this.setState({ redirect_to, isLoading: false });
  };

  componentDidMount() {
    const { id = 0 } = this.props.match.params;
    if (id && id > 0) {
      this.loadService(id);
    }
  }
}
export default withUser(withSplashMessage(ClientService));



// WEBPACK FOOTER //
// ./src/components/client/ClientService.js